/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Broker_Actions_TitleInputs */

const cs_import_broker_actions_title = /** @type {(inputs: Import_Broker_Actions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plán párování makléřů`)
};

const en_import_broker_actions_title = /** @type {(inputs: Import_Broker_Actions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broker match plan`)
};

/**
* | output |
* | --- |
* | "Broker match plan" |
*
* @param {Import_Broker_Actions_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_broker_actions_title = /** @type {((inputs?: Import_Broker_Actions_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Broker_Actions_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_broker_actions_title(inputs)
	return cs_import_broker_actions_title(inputs)
});